import React from 'react';
import { Carousel } from '3d-react-carousal';
import { CertiContainer, CertiWrapper, CertiH1 } from './CertiElement';
import Certi5 from '../../assets/images/0001.jpg';
import Certi4 from '../../assets/images/cloud certi (1)_pages-to-jpg-0001.jpg';
import Certi2 from '../../assets/images/Niraj Srivastava (2)_page-0001.jpg';
import Certi1 from '../../assets/images/217-niraj-srivastava-0325_pages-to-jpg-0001.jpg';
import Certi3 from '../../assets/images/Niraj Srivastava_Intership-certificate (1) (1)_pages-to-jpg-0001.jpg';
import Certi10 from '../../assets/images/Cuvette Fullstack Development Certificate - Niraj Srivastava_page-0001.jpg';

const Certi = () => {
  let slides = [
    <img src={Certi10} alt="10" />,
    <img src={Certi1} alt="1" />,
    <img src={Certi2} alt="2" />,
    <img src={Certi3} alt="3" />,
    <img src={Certi4} alt="4" />,
    <img src={Certi5} alt="5" />,
    <img
      src="https://udemy-certificate.s3.amazonaws.com/image/UC-75b53b48-e89b-4a7f-adb1-683e4c45ffd7.jpg?v=1624192603000/200/200/?random"
      alt="7"
    />,
    <img
      src="https://udemy-certificate.s3.amazonaws.com/image/UC-908911e4-6fa4-40a6-aac3-3f11cefa088b.jpg?v=1591964479000"
      alt="8"
    />,
    <img
      src="https://udemy-certificate.s3.amazonaws.com/image/UC-ab99b81e-eace-40ad-9fa2-75b885da7aae.jpg?v=1588253972000"
      alt="9"
    />,
  ];
  return (
    <CertiContainer id="certi">
      <CertiWrapper>
        <CertiH1>Certification</CertiH1>
        <Carousel slides={slides} />
      </CertiWrapper>
    </CertiContainer>
  );
};

export default Certi;
